import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'normalize.css'
import Vant from 'vant';
import 'vant/lib/index.css';
import F2 from "@antv/f2/lib/index-all";
import request from './api/request.js'
import ajax from './api/ajax.js'
import {ajaxForm} from './api/ajaxForm.js'
import "./routerOperation.js"
import "@/assets/css/common.scss";
// console.log(croods.customPlugin({action: "UserPlugin.login",}))
// croods.customPlugin({
//   action: "UserPlugin.login",
//   params: {},
//   success: function(res) {
//     console.log(res)
//   },
//   fail: function(msg) {}
// })
// croods.customPlugin().success(function(res){
//   console.log(res)
// }).fail(function(msg){
//   console.log(msg)
// })
Vue.use(Vant);
Vue.prototype.$request = request;
Vue.prototype.$ajax = ajax;
Vue.prototype.$ajaxForm = ajaxForm;
Vue.prototype.$F2 = F2;
Vue.prototype.$store = store;
Vue.config.ignoredElements = ['wx-open-launch-weapp']
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
